import { render, staticRenderFns } from "./taobao.vue?vue&type=template&id=baff9cc0&scoped=true&"
import script from "./taobao.vue?vue&type=script&lang=js&"
export * from "./taobao.vue?vue&type=script&lang=js&"
import style0 from "./taobao.vue?vue&type=style&index=0&id=baff9cc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baff9cc0",
  null
  
)

export default component.exports